@if (task) {
    <div class="client-container d-flex flex-column">
    <div class="view">
        <!-- Tabs -->
        <mat-tab-group #matTabGroup (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>Task</small></span>
                        <span class="object-name">{{ task.name }}</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Overview">
                <div class="tab-content">
                    <app-task-report [metricsData]="reportData!"></app-task-report>
                    <mat-card class="cardWithShadow">
                        <mat-card-header class="d-flex">
                            <div class="m-r-auto">
                                <mat-card-title>{{ task.name | titlecase }}</mat-card-title>
                            </div>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="table-responsive m-t-30">
                                @if (reportData && reportData.length) {
                                    <table [dataSource]="reportData" class="mat-elevation-z8" mat-table>
                                        <!-- Task ID Column -->
                                        <ng-container matColumnDef="reportDate">
                                            <th *matHeaderCellDef mat-header-cell> Date</th>
                                            <td *matCellDef="let element"
                                                mat-cell> {{ element.reportDate | date:'mediumDate' }}
                                            </td>
                                        </ng-container>
                                        <!-- Task Call Type Column -->
                                        <ng-container matColumnDef="taskCallType">
                                            <th *matHeaderCellDef mat-header-cell> Task Call Type</th>
                                            <td *matCellDef="let element" mat-cell> {{ element.taskCallType }}</td>
                                        </ng-container>
                                        <!-- Model Column -->
                                        <ng-container matColumnDef="model">
                                            <th *matHeaderCellDef mat-header-cell> Model</th>
                                            <td *matCellDef="let element" mat-cell> {{ element.model }}</td>
                                        </ng-container>
                                        <!-- Response Type Column -->
                                        <ng-container matColumnDef="responseType">
                                            <th *matHeaderCellDef mat-header-cell> Response Type</th>
                                            <td *matCellDef="let element" mat-cell> {{ element.responseType }}</td>
                                        </ng-container>
                                        <!-- Total Called Column -->
                                        <ng-container matColumnDef="totalTaskCalled">
                                            <th *matHeaderCellDef mat-header-cell> Total Called</th>
                                            <td *matCellDef="let element" mat-cell> {{ element.totalTaskCalled }}</td>
                                        </ng-container>
                                        <!-- Total Completed Column -->
                                        <ng-container matColumnDef="totalTaskCompleted">
                                            <th *matHeaderCellDef mat-header-cell> Total Completed</th>
                                            <td *matCellDef="let element" mat-cell> {{ element.totalTaskCompleted }}
                                            </td>
                                        </ng-container>
                                        <!-- Total Failed Column -->
                                        <ng-container matColumnDef="totalTaskFailed">
                                            <th *matHeaderCellDef mat-header-cell> Total Failed</th>
                                            <td *matCellDef="let element" mat-cell> {{ element.totalTaskFailed }}</td>
                                        </ng-container>
                                        <!-- Average Time Taken Column (in seconds) -->
                                        <ng-container matColumnDef="avgTaskTimeTaken">
                                            <th *matHeaderCellDef mat-header-cell> Avg Time Taken (s)</th>
                                            <td *matCellDef="let element" mat-cell>
                                                {{ (element.avgTaskTimeTaken / 1000) | number:'1.2-2' }}
                                            </td>
                                        </ng-container>
                                        <!-- Header and Row Declarations -->
                                        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                                        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
                                    </table>
                                }
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>
            <!-- Settings Tab -->
            @if (task) {
                <mat-tab label="Settings">
                    <div class="tab-content">
                        <app-client-object-settings [clientSettingsForm]="settingsForm"
                                                    [object]="task"></app-client-object-settings>
                        <app-task-general-settings [settingsForm]="settingsForm"></app-task-general-settings>
                        <app-schedule-settings [scheduleSettingsForm]="scheduleSettingsForm"
                                               [scheduleSettings]="task.scheduleSettings"></app-schedule-settings>
                        <app-notification-settings [notificationForm]="notificationsForm"
                                                   [notificationSettings]="task.notificationSettings"></app-notification-settings>
                    </div>
                </mat-tab>
            }
            <!-- Functions Tab -->
            <mat-tab label="Functions">
                @if (task) {
                    <div class="tab-content">
                        <app-listings (selectionChange)="onFunctionRefsChange($event)"
                                      [multiselect]="true"
                                      [selectedItems]="task.functionRefs"
                                      selectionObjectType="functions"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <!-- Assistants Tab -->
            <mat-tab label="Files">
                @if (task) {
                    <div class="tab-content">
                        <app-listings (selectionChange)="onFileRefsChange($event)"
                                      [multiselect]="true"
                                      [selectedItems]="task.fileRefs"
                                      selectionObjectType="files"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <mat-tab label="Tasks">
                @if (task) {
                    <div class="tab-content">
                        <app-listings (selectionChange)="onTaskChange($event)"
                                      [disallowSelectionForIds]="[task.id]"
                                      [multiselect]="true"
                                      [selectedItems]="task.completionRefs"
                                      selectionObjectType="tasks"
                                      selectionType="multi"></app-listings>
                    </div>
                }
            </mat-tab>
            <mat-tab label="Run">
                @if (task) {
                    <div class="tab-content">
                        <app-task-runner [task]="task"></app-task-runner>
                    </div>
                }
            </mat-tab>
            <mat-tab label="Previous runs">
                <div class="tab-content">
                    <!-- Results Table -->
                    <app-task-previous-runs [allTasks]="allTasks"></app-task-previous-runs>
                </div>
            </mat-tab>
        </mat-tab-group>
        <!-- Save and Delete Buttons -->
        @if ([1, 6, 7, 8, 9].indexOf(matTabGroup.selectedIndex!) === -1) {
            <div class="d-flex gap-3 pt-3">
                <button (click)="save()" [disabled]="isSaving || (!isFormTouched())" color="primary" mat-raised-button>
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
                <button (click)="delete()" [disabled]="isDeleting" color="warn" mat-raised-button>
                    {{ isDeleting ? 'Deleting...' : 'Delete' }}
                </button>
        </div>
        }
    </div>
    </div>
}
